export enum Zona{
    Ninguno = 0,
    Norte = 1,
    Sur = 2
}